import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPlusCircle = () => {
  return (
    <g>
      <path d="m8 .03a7.97 7.97 0 1 0 7.9707 7.97 7.979 7.979 0 0 0 -7.9707-7.97zm0 14.44a6.47 6.47 0 1 1 6.4707-6.47 6.4778 6.4778 0 0 1 -6.4707 6.47z" />
      <path d="m11.3564 7.25h-2.6064v-2.6067a.75.75 0 1 0 -1.5 0v2.6067h-2.6064a.75.75 0 1 0 0 1.5h2.6064v2.6069a.75.75 0 1 0 1.5 0v-2.6069h2.6065a.75.75 0 1 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconPlusCircle);
